/* ============
 * Slot Mixin
 * ============
 *
 * Mixins are used to easily expand Vue components.
 * This slot-mixin, will add the hasSlot-method
 * to the specified Vue component.
 */

import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';

@Mixin
export class DownloadFileMixin extends Vue {
  downloadFile (response: any) {
    let headerLine = response.headers['content-disposition'];
    let startFileNameIndex = headerLine.indexOf('"') + 1;
    let endFileNameIndex = headerLine.lastIndexOf('"');
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', headerLine.substring(startFileNameIndex, endFileNameIndex));
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
